import Chip from '@mui/material/Chip';

import { type VehicleAvailability } from '@/services/vehicles/types';
import { availabilityLabels } from '@/utils/vehicleFormat';

/** Shown only when a car is not simply available. Text, not colour, carries the state. */
export function AvailabilityChip({ availability }: { availability: VehicleAvailability }) {
  if (availability === 'available') return null;
  return (
    <Chip
      size="small"
      label={availabilityLabels[availability]}
      color={availability === 'sold' ? 'default' : 'warning'}
      sx={{ fontWeight: 700 }}
    />
  );
}
